'use client';

import { c as _c } from "react/compiler-runtime";
import useUser from '@shared/utils/hooks/useUser';
import { AvatarWithSettings } from './AvatarWithSettings';
import { useNewPostContext } from './NewPostContext';
import { NewPostInputSection } from './NewPostInputSection';
export const NewPostLayout = () => {
  const $ = _c(26);
  const {
    content,
    refDraftPostId,
    spaceSlug,
    anonymousPost,
    isBoardPost
  } = useNewPostContext();
  const {
    currentUser
  } = useUser();
  const overSuggested = !isBoardPost && content.length > 300;
  const t0 = `text-xs ${content.length > 4900 ? "font-emphasis text-destructive" : overSuggested ? "text-yellow-500" : "text-textSecondary/50"}`;
  let t1;
  if ($[0] !== content.length) {
    t1 = content.length.toLocaleString();
    $[0] = content.length;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isBoardPost || content.length > 300 ? "5,000" : "300";
  let t3;
  if ($[2] !== t0 || $[3] !== t1 || $[4] !== t2) {
    t3 = <div className="flex items-center justify-end gap-2 px-1"><span className={t0}>{t1}/{t2}</span></div>;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== content.length || $[7] !== overSuggested) {
    t4 = content.length > 4900 ? <p className="px-1 text-start text-sm text-destructive">Content must be below 5,000 characters. ({content.length.toLocaleString()}/5,000)</p> : overSuggested ? <p className="px-1 text-start text-sm text-destructive">We suggest keeping your content under 300 characters. ({content.length.toLocaleString()}/300)</p> : null;
    $[6] = content.length;
    $[7] = overSuggested;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== spaceSlug) {
    t5 = spaceSlug && <p className="px-1 text-start text-sm text-textSecondary/60">Posting to s/{spaceSlug}</p>;
    $[9] = spaceSlug;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const extraContent = t6;
  const t7 = Boolean(refDraftPostId);
  let t8;
  if ($[15] !== t7) {
    t8 = <AvatarWithSettings hidePrivate={t7} size={40} />;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== anonymousPost || $[18] !== currentUser) {
    t9 = <div className="flex min-w-0 flex-col">{anonymousPost ? <><p className="max-w-[200px] truncate text-sm font-semibold text-textPrimary">Anonymous User</p><span className="max-w-[150px] truncate text-xs text-textSecondary/70">@Anonymous User</span></> : <><p className="max-w-[200px] truncate text-sm font-semibold text-textPrimary">{currentUser.name}</p><span className="max-w-[150px] truncate text-xs text-textSecondary/70">@{currentUser.username}</span></>}</div>;
    $[17] = anonymousPost;
    $[18] = currentUser;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="flex items-center gap-2">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== extraContent || $[24] !== t10) {
    t11 = <div className="min-h-0 overflow-y-auto rounded-xl bg-background-primary px-3 py-2"><NewPostInputSection extraContent={extraContent} avatar={t10} /></div>;
    $[23] = extraContent;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};